import { CREATE_NOTIFICATION, CREATE_NOTIFICATION_FAIL, CREATE_NOTIFICATION_SUCCESS, CREATE_EDIT_NOTIFICATION_API_STATUS, GET_ALL_NOTIFICATIONS, GET_ALL_NOTIFICATIONS_SUCCESS, GET_ALL_NOTIFICATIONS_FAIL, GET_NOTIFICATIONS_BY_ID, GET_NOTIFICATIONS_BY_ID_SUCCESS, GET_NOTIFICATIONS_BY_ID_FAIL, UPDATE_NOTIFICATION, UPDATE_NOTIFICATION_SUCCESS, UPDATE_NOTIFICATION_FAIL, CREATE_NOTIFICATION_DISABLE, SEARCH_NOTIFICATION, SEARCH_NOTIFICATION_SUCCESS, SEARCH_NOTIFICATION_FAIL, NOTIFICATION_LOADER, BEFORE_LOGIN_MARQUEE, BEFORE_LOGIN_MARQUEE_SUCCESS, BEFORE_LOGIN_MARQUEE_FAIL, CANCLE_NOTIFICATIONS_BY_ID, CANCLE_NOTIFICATIONS_BY_ID_SUCCESS, CANCLE_NOTIFICATIONS_BY_ID_FAIL } from "../../actionLabels/addNotification/addNotification";

export const createNotificationsAction = (payload) => {
  return {
    type: CREATE_NOTIFICATION,
    payload: payload,
  };
};

export const createNotificationsSuccess = (notifications) => {
  return {
    type: CREATE_NOTIFICATION_SUCCESS,
    payload: notifications,
  };
};

export const createNotificationFailure = (error) => ({
  type: CREATE_NOTIFICATION_FAIL,
  payload: error,
});

export const createEditNotificationApiStatus = (data) => {
  return {
    type: CREATE_EDIT_NOTIFICATION_API_STATUS,
    payload: { data: data },
  };
};

export const createNotificationDisable = (data) => {
  return {
    type: CREATE_NOTIFICATION_DISABLE,
    payload: { data: data },
  };
};

export const notificationLoader = (data) => {
  return {
    type: NOTIFICATION_LOADER,
    payload: { data: data },
  };
};



//get all notification actions//

export const getAllNotifications = (notification) => ({
  type: GET_ALL_NOTIFICATIONS,
  payload: notification
});

export const getAllNotificationsSuccess = (notifications) => ({
  type: GET_ALL_NOTIFICATIONS_SUCCESS,
  payload: notifications,
});

export const getAllNotificationsFail = (error) => ({
  type: GET_ALL_NOTIFICATIONS_FAIL,
  payload: error,
});

// Action creator for getting notification by ID

export const getNotificationByIdAction = (marqueeId) => {
  return {
    type: GET_NOTIFICATIONS_BY_ID,
    payload: marqueeId,
  };
};

export const getNotificationByIdActionSuccess = (notificationData) => {
  return {
    type: GET_NOTIFICATIONS_BY_ID_SUCCESS,
    payload: notificationData,
  };
};

export const getNotificationByIdActionFail = (error) => ({
  type: GET_NOTIFICATIONS_BY_ID_FAIL,
  payload: error,
});

// Action creator for cancling notification by ID

export const cancleNotificationByIdAction = (marqueeId) => {
  return {
    type: CANCLE_NOTIFICATIONS_BY_ID,
    payload: marqueeId,
  };
};

export const cancleNotificationByIdActionSuccess = (notificationData) => {
  return {
    type: CANCLE_NOTIFICATIONS_BY_ID_SUCCESS,
    payload: notificationData,
  };
};

export const cancleNotificationByIdActionFail = (error) => ({
  type: CANCLE_NOTIFICATIONS_BY_ID_FAIL,
  payload: error,
});

// Action creator for updating a Notification
export const updateNotificationAction = (updatedNotificationData) => {
  return {
    type: UPDATE_NOTIFICATION,
    payload: {
      updatedNotificationData,
    },
  };
};

export const updateNotificationActionSuccess = (updatedNotificationData) => {
  return {
    type: UPDATE_NOTIFICATION_SUCCESS,
    payload: updatedNotificationData,
  };
};

export const updateNotificationActionFail = (error) => ({
  type: UPDATE_NOTIFICATION_FAIL,
  payload: error,
});

// Action creator for searching a Notification
export const searchNotificationAction = (searchTerm) => {
  return {
    type: SEARCH_NOTIFICATION,
    payload: searchTerm,
  };
};

export const searchNotificationActionSuccess = (searchResults) => {
  return {
    type: SEARCH_NOTIFICATION_SUCCESS,
    payload: searchResults,
  };
};

export const searchNotificationActionFail = (error) => ({
  type: SEARCH_NOTIFICATION_FAIL,
  payload: error,
});

// ACTIONS FOR BEFORE LOGIN MARQUEE//
export const getBeforeLoginMarqueeAction = () => {
  return {
    type: BEFORE_LOGIN_MARQUEE,
  };
};

export const getBeforeLoginMarqueeActionSuccess = (marqueeText) => {
  return {
    type: BEFORE_LOGIN_MARQUEE_SUCCESS,
    payload: marqueeText,
  };
};

export const getBeforeLoginMarqueeActionFail = (error) => ({
  type: BEFORE_LOGIN_MARQUEE_FAIL,
  payload: error,
}); 